import React from 'react';
import {
  BookmarkOutlineIcon,
  CalendarOutlineIcon,
  CartOutlineIcon,
  ChatIcon,
  DollarIcon,
  GiftIcon,
  HomeOutlineIcon,
  PaperTicketsOutlineIcon,
  PlusIcon,
  ProfileOutlineIcon,
  SearchSolidIcon,
  SellOutlineIcon,
  SettingsIcon,
  TicketAlertOutlineIcon,
} from 'src/svgs/Viagogo';
import { IconsFill, IconsProps } from 'src/svgs/Viagogo';

export type CustomTabIconKey =
  | 'home'
  | 'cart'
  | 'search'
  | 'settings'
  | 'tickets'
  | 'sell'
  | 'chat'
  | 'plus'
  | 'calendar'
  | 'dollar'
  | 'profile'
  | 'bookmark'
  | 'alert'
  | 'gift';

type IconComponent = (props: IconsProps) => React.ReactNode;

export const CUSTOM_TAB_ICONS: Record<CustomTabIconKey, IconComponent> = {
  home: HomeOutlineIcon,
  cart: CartOutlineIcon,
  search: SearchSolidIcon,
  settings: SettingsIcon,
  tickets: PaperTicketsOutlineIcon,
  sell: SellOutlineIcon,
  chat: ChatIcon,
  plus: PlusIcon,
  calendar: CalendarOutlineIcon,
  dollar: DollarIcon,
  profile: ProfileOutlineIcon,
  bookmark: BookmarkOutlineIcon,
  alert: TicketAlertOutlineIcon,
  gift: GiftIcon,
};

export const CUSTOM_TAB_ICON_LABELS: Record<CustomTabIconKey, string> = {
  home: 'Home',
  cart: 'Cart',
  search: 'Search',
  settings: 'Settings',
  tickets: 'Tickets',
  sell: 'Sell',
  chat: 'Chat',
  plus: 'Plus',
  calendar: 'Calendar',
  dollar: 'Dollar',
  profile: 'Profile',
  bookmark: 'Bookmark',
  alert: 'Alert',
  gift: 'Gift',
};

export const DEFAULT_ICON_KEY: CustomTabIconKey = 'home';

interface CustomTabIconProps extends IconsProps {
  iconKey: string;
}

export const CustomTabIcon = ({
  iconKey,
  ...props
}: CustomTabIconProps): React.ReactNode => {
  const IconComponent =
    CUSTOM_TAB_ICONS[iconKey as CustomTabIconKey] ?? HomeOutlineIcon;
  return <IconComponent fill={IconsFill.currentColor} {...props} />;
};
